<template>
  <div class="input-group date-picker">
    <input class="form-control date-picker-notafter" :id="'notAfterDate' + removeSpecialSymboy(item.userId)" name="sdate" type="text" v-on:blur="checkEditDate"/>
    <span class="input-group-addon icon_date_notbefore">
      <i class="fa fa-calendar bigger-110"></i>
    </span>
    <input type="text" name="tdateafter" class="form-control" :id="'notAfterTime' + removeSpecialSymboy(item.userId)" v-on:blur="checkEditTime"/>
    <span class="input-group-addon">
      <i class="fa fa-clock-o bigger-110"></i>
    </span>
  </div>
</template>

<script>

export default {
  props: ['item'],
  data () {
    return {
    }
  },
  methods: {
    checkEditDate () {
      var vm = this
      $('.datepicker table tr td.day').click(function () {
        vm.updateEditStatus()
      })
    },
    checkEditTime () {
      var vm = this
      $('.bootstrap-timepicker-widget table tr td a').click(function () {
        vm.updateEditStatus()
      })
    },
    updateEditStatus () {
      this.$emit('edited')
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    }
  },
  mounted () {
    $('input[name=sdate]').attr('autocomplete', 'off')
    $('input[name=tdateafter]').attr('autocomplete', 'off')
    $('input[name=tdate]').attr('autocomplete', 'off')
    $('input[name=sdate]').datepicker({
      language: 'ja',
      format: 'yyyy/mm/dd',
      autoclose: true,
      todayHighlight: true,
      setDate: new Date()
    })
    $('input[name=tdate]').timepicker({
      defaultTime: '00:00:00',
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false
    })
    $('input[name=tdateafter]').timepicker({
      defaultTime: '23:59:59',
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false
    })
    $('input[name=sdate]').datepicker().datepicker('setDate', new Date())
  }
}
</script>



// WEBPACK FOOTER //
// src/views/gate/DatePickerAfter.vue